// Old Copilot domains
export const copilotPrimaryDomainHostname = {
  prod: 'copilot.app' as const,
  staging: 'copilot-staging.app' as const,
};

export const copilotClientDomainHostname = {
  prod: 'copilot.app' as const,
  staging: 'copilot-staging.app' as const,
};

// New Assembly domains
export const assemblyPrimaryDomainHostname = {
  prod: 'assembly.com' as const,
  staging: 'assembly-staging.com' as const,
};

export const assemblyClientDomainHostname = {
  prod: 'myassembly.com' as const,
  staging: 'myassembly-staging.com' as const,
};

export const primaryDomainHostname = {
  ...assemblyPrimaryDomainHostname,
};

export const clientDomainHostname = {
  ...copilotClientDomainHostname,
};

// Combined domains for backward compatibility
export const allPrimaryDomainHostnames = {
  prod: [assemblyPrimaryDomainHostname.prod, copilotPrimaryDomainHostname.prod],
  staging: [
    assemblyPrimaryDomainHostname.staging,
    copilotPrimaryDomainHostname.staging,
  ],
};

export const allClientDomainHostnames = {
  prod: [assemblyClientDomainHostname.prod, copilotClientDomainHostname.prod],
  staging: [
    assemblyClientDomainHostname.staging,
    copilotClientDomainHostname.staging,
  ],
};

export const reservedSubdomains = [
  'dashboard',
  'notification',
  'notifications',
  'mail',
  'link',
  'links',
  'docs',
  'blog',
  'api',
  // We are not splitting with a dash because the portal URL is already removing any separator.
  // Therefore, we would check the words without splitting them. This will catch the following cases:
  // api-admin, app-api, api-internal ...etc.
  'appapi',
  'apiadmin',
  'apiclient',
  'apiinternal',
  'secure',
  'status',
  'support',
  'www',
  'try',
  'auth',
  'internalauth',
  'clientauth',
  'get',
  'http',
  'https',
  'admin',
  'administrator',
];
